import { Col } from "antd";
import { lazy } from "react";
import { Route } from "react-router";
import { TestAttributePrefix, TestContext } from "core/components/testAttributes";
import { withPermissions } from "common/permissions/components/withPermission";

const HyperwalletUserPageContainer = lazy(() =>
    import("../containers/HyperwalletUserPageContainer").then((module) => ({
        default: module.HyperwalletUserPageContainer,
    }))
);

export function Payment() {
    return (
        <TestContext.Provider value={TestAttributePrefix.FEATURE_PAYMENT}>
            <Route
                path={"/:region/venue/:location/payments"}
                render={() => (
                    <Col span={24} md={24} className="content__col">
                        <div className="content__col-edit">
                            <Route component={withPermissions(HyperwalletUserPageContainer, "payment:read")} />
                        </div>
                    </Col>
                )}
            />
        </TestContext.Provider>
    );
}
